






























import Vue from 'vue'
import LocationMarker from '@/components/Global/LocationMarker.vue'
import { apiGetBusinessEntitiesPaginated } from '@/api'
import { entityHeaders } from './headers'
import { mutations, portalState } from '../../state'

export default Vue.extend({
  name: 'EntitiesTable',
  props: {
    selectedBusiness: Object,
    marginTop: String,
    search: String,
    tab: String
  },
  components: { LocationMarker },
  computed: {
    headers () {
      const tableHeaders = entityHeaders(this.t)
      if (!this.hasCustomers) {
        const userNameIndex = tableHeaders.findIndex((e: {value: string}) => e.value === 'user_name')
        tableHeaders.splice(userNameIndex, 1)
        const subscriptionIndex = tableHeaders.findIndex((e: {value: string}) => e.value === 'subscription')
        tableHeaders.splice(subscriptionIndex, 1)
      }
      return tableHeaders
    },
    hasCustomers () {
      if (portalState.user.role === 'Super Admin') return true
      return portalState.user.businesses.some((b: { has_customers: boolean }) => b.has_customers)
    }
  },
  data () {
    return {
      selected: [],
      entities: [],
      loading: true,
      options: {},
      controller: null,
      totalServerItems: 0,
      footerProps: { itemsPerPageOptions: [10, 25, 50] },
      queryParams: { direction: 'desc' },
      timeout: null
    }
  },
  methods: {
    initialize () {
      if (this.tab !== 'entities') return
      if (this.controller) this.controller.abort()
      this.controller = new AbortController()

      this.entities = []
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      if (sortBy[0]) {
        this.queryParams.direction = sortDesc[0] ? 'asc' : 'desc'
      } else {
        this.queryParams.direction = 'desc'
      }
      const { id } = this.selectedBusiness
      const searchParam = this.search !== '' && typeof this.search === 'string' ? `&search=${this.search.toLowerCase()}` : ''
      const paginationConfig = {
        id, page, limit: itemsPerPage, direction: this.queryParams.direction, search: searchParam, signal: this.controller.signal
      }
      apiGetBusinessEntitiesPaginated(paginationConfig)
        .then((res: any) => {
          this.entities = res?.data?.data
          if (res?.data?.pagination?.total_pages < page) this.options.page = 1
          this.totalServerItems = res?.data?.pagination?.total
          this.loading = false
        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        }).finally(() => this.gsapFadeIn())
    }
  },
  watch: {
    options: {
      handler () {
        this.initialize()
      },
      deep: true
    },
    search () {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.initialize()
      }, 500)
    },
    selectedBusiness () {
      this.initialize()
    },
    selected () {
      this.$emit('selectedLength', this.selected.map((entity: {id: string}) => entity.id))
    }
  }
})
